// Client wrappers for /api/excursions/interest. The player_id is derived
// server-side from the session cookie — never trust the client to claim
// a player_id.

const TRIP_DEFAULT = 'juneau-2026';

async function postJson(url, body) {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body),
  });
  let data;
  try {
    data = await res.json();
  } catch {
    data = {};
  }
  if (!res.ok) {
    const err = new Error(data.message || data.error || `${url} → ${res.status}`);
    err.status = res.status;
    err.detail = data;
    throw err;
  }
  return data;
}

async function getJson(url) {
  const res = await fetch(url, { credentials: 'include' });
  if (!res.ok) throw new Error(`${url} → ${res.status}`);
  // Plain `vite` dev (without `netlify dev`) returns the SPA index.html
  // for unknown routes — JSON.parse would explode. Treat that as
  // "endpoint unavailable" and degrade to empty rather than crashing the UI.
  const ct = res.headers.get('content-type') || '';
  if (!ct.includes('json')) {
    const err = new Error('api_unavailable');
    err.status = 'api_unavailable';
    throw err;
  }
  return res.json();
}

export async function fetchExcursionInterests({ tripId = TRIP_DEFAULT } = {}) {
  return getJson(`/api/excursions/interest?trip_id=${tripId}`);
}

export async function setExcursionInterest({ tripId = TRIP_DEFAULT, excursionId, interest }) {
  return postJson('/api/excursions/interest', {
    trip_id: tripId,
    excursion_id: excursionId,
    interest,
  });
}
